package org.example.project.utils

import kotlinx.browser.document
import kotlinx.browser.window

/** Copies text in both secure and locally served browser contexts. */
fun copyTextToClipboard(text: String) {
    val value = text.trim()
    if (value.isBlank()) return

    runCatching {
        window.navigator.asDynamic().clipboard?.writeText(value)
    }

    runCatching {
        val textArea = document.createElement("textarea")
        textArea.asDynamic().value = value
        textArea.asDynamic().setAttribute("readonly", "true")
        textArea.asDynamic().style.position = "fixed"
        textArea.asDynamic().style.top = "-1000px"
        textArea.asDynamic().style.opacity = "0"
        document.body?.appendChild(textArea)
        textArea.asDynamic().focus()
        textArea.asDynamic().select()
        document.asDynamic().execCommand("copy")
        document.body?.removeChild(textArea)
    }
}
